import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { setLanguage } from './slices/languageSlice';
import { HashRouter } from "react-router-dom";
import LoginIndex from './Login/Routes/LoginIndex';
import CustomLoader from "./Utility/Components/CustomLoader";
import RoutesIndex from './Routes/index';

function App() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const language = useSelector((state) => state.language.language);
  const isLoading = useSelector((state) => state?.loader?.isLoading || false);
  const { userDetails, token } = useSelector((state) => state.user);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    dispatch(setLanguage(lng));
  };

  console.log("userDetails", userDetails, "token", token);

  return (
    <CustomLoader active={isLoading}>
      <HashRouter>
        {(() => {
          if (userDetails && Object.keys(userDetails).length > 0 && token !== "") {
            console.log("GlobalRoute app js");
            return <RoutesIndex />;
          }
          console.log("LoginIndex app js");
          return <LoginIndex />;
        })()}

      </HashRouter>
    </CustomLoader>
  );
}

export default App;
